import React, { useContext } from "react"

import MicrocopyContext from "~contexts/MicrocopyContext"
import LoggedOutPanel from "./LoggedOutPanel"
import LoggedInPanel from "./LoggedInPanel"

import * as style from "./style.module.scss"

const CreateAppModal = ({ processing, onToggleModal, ...props }) => {
  const microcopy = useContext(MicrocopyContext)
  return (
    <div className={style.modal} data-processing={processing}>
      <header>
        {microcopy.text("app_button.title")}
        <a onClick={onToggleModal}>
          {microcopy.text("app_button.buttons.close")}
        </a>
      </header>

      <LoggedOutPanel />
      <LoggedInPanel {...props} />
    </div>
  )
}

export default CreateAppModal
